(() => {
    // ── Variant availability tracking — runs immediately, outside init ──
    const productData = JSON.parse(
        document.querySelector("[data-product-json]")?.textContent || "{}",
    );

    const initialVariantId =
        new URLSearchParams(window.location.search).get("variant") ||
        document.querySelector('product-form [name="id"]')?.value;

    let selectedVariantAvailable = true;

    if (productData.variants && initialVariantId) {
        const initialVariant = productData.variants.find(
            (v) => v.id === initialVariantId,
        );
        if (initialVariant) selectedVariantAvailable = initialVariant.available;
    }

    function toggleRechargeWidget(available) {
        const rechargeContainer = document
            .querySelector("recharge-subscription-widget")
            ?.closest(".shopify-app-block");
        if (rechargeContainer) {
            rechargeContainer.style.display = available ? "" : "none";
        }
    }

    // Apply immediately in case widget is already in DOM
    toggleRechargeWidget(selectedVariantAvailable);

    // Watch for widget rendering after the fact and hide it if unavailable
    if (!selectedVariantAvailable) {
        const rechargeObserver = new MutationObserver(() => {
            const rechargeContainer = document
                .querySelector("recharge-subscription-widget")
                ?.closest(".shopify-app-block");
            if (rechargeContainer) {
                rechargeContainer.style.display = "none";
                rechargeObserver.disconnect();
            }
        });
        rechargeObserver.observe(document.body, {childList: true, subtree: true});
    }

    // ── Variant change handling — also outside init ──
    document.addEventListener("variantChange", (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;

        selectedVariantAvailable = variant.available;
        toggleRechargeWidget(variant.available);

        const btn = document.querySelector(
            ".main-product__actions .main-product__form-buttons--addtocart button",
        );
        if (btn) {
            btn.dataset.comparePrice = variant.compare_at_price || "";
            btn.dataset.price = variant.price || "";
        }
    });

    function init() {
        const rechargeWidget = document.querySelector(
            "recharge-subscription-widget",
        );

        if (!rechargeWidget) {
            return true;
        }

        const productDetailsContainer = rechargeWidget.closest(
            "[data-product-details]",
        );

        if (!rechargeWidget?.shadowRoot) return false;

        const shadowRoot = rechargeWidget.shadowRoot;

        const subscriptionRadio = shadowRoot.querySelector(
            'input[value="subscription"]',
        );
        const onetimeRadio = shadowRoot.querySelector('input[value="onetime"]');

        if (!subscriptionRadio || !onetimeRadio) return false;

        // ── Price update ──
        function updatePrice() {
            if (!selectedVariantAvailable) return;

            const isSubscription = subscriptionRadio?.checked;
            const onetimePriceElement = shadowRoot.querySelector(
                ".rc-selection__onetime .rc-price",
            );
            const onetimePrice = onetimePriceElement?.textContent.trim();

            const atcBtn = document.querySelector(
                ".main-product__actions .main-product__form-buttons--addtocart button",
            );
            const comparePriceCents = parseInt(
                atcBtn?.dataset.comparePrice || "0",
                10,
            );
            const currentPriceCents = parseInt(atcBtn?.dataset.price || "0", 10);
            const comparePrice =
                comparePriceCents > 0 && comparePriceCents > currentPriceCents
                    ? formatMoney(comparePriceCents)
                    : "";

            if (isSubscription) {
                productDetailsContainer.classList.add("recharge-subscription-selected");
                const subPriceElement = shadowRoot.querySelector(
                    '.rc-purchase-option__subscription [part*="discounted-price"]',
                );
                const subscriptionPrice = subPriceElement?.textContent
                    .replace(", Discounted price:", "")
                    .trim();
                updateButtonPrice(onetimePrice, subscriptionPrice);
                if (window.stickyBarSync) {
                    window.stickyBarSync(
                        true,
                        onetimePrice,
                        subscriptionPrice,
                        comparePrice,
                    );
                }
            } else {
                productDetailsContainer.classList.remove(
                    "recharge-subscription-selected",
                );
                updateButtonPrice(onetimePrice);
                if (window.stickyBarSync) {
                    window.stickyBarSync(false, onetimePrice, "", comparePrice);
                }
            }
        }

        document.addEventListener("planChange", (event) => {
            console.log("Plan changed:", event.detail);
            updatePrice();
        });

        subscriptionRadio?.addEventListener("change", updatePrice);
        onetimeRadio?.addEventListener("change", updatePrice);

        // When variant changes to available, re-run updatePrice after theme settles
        document.addEventListener("variantChange", (event) => {
            const variant = event.detail?.variant;
            if (!variant) return;
            if (variant.available) {
                setTimeout(updatePrice, 150);
            }
        });

        // Observe the button for DOM changes by the theme
        const atcButton = document.querySelector(
            ".main-product__actions .main-product__form-buttons--addtocart button",
        );
        if (atcButton) {
            const buttonObserver = new MutationObserver(() => {
                if (
                    selectedVariantAvailable &&
                    !atcButton.querySelector(".button__text")
                ) {
                    setTimeout(updatePrice, 0);
                }
            });
            buttonObserver.observe(atcButton, {childList: true});
        }

        updatePrice();

        return true;
    }

    function formatMoney(cents) {
        if (!cents || cents === "0") return "";
        try {
            return Shopify.formatMoney(cents, window.theme.moneyFormat);
        } catch (e) {
            return "$" + (parseInt(cents, 10) / 100).toFixed(2);
        }
    }

    function updateButtonPrice(price, subscriptionPrice) {
        const addToCartButton = document.querySelector(
            ".main-product__actions .main-product__form-buttons--addtocart button",
        );

        if (!addToCartButton) {
            console.warn("Add to cart button not found");
            return;
        }

        if (
            addToCartButton.hasAttribute("disabled") &&
            addToCartButton.querySelector(".klaviyo-bis-trigger")
        ) {
            return;
        }

        const priceLabel = subscriptionPrice ? "Subscribe" : "Add to cart";
        const comparePriceCents = parseInt(
            addToCartButton.dataset.comparePrice || "0",
            10,
        );
        const currentPriceCents = parseInt(
            addToCartButton.dataset.price || "0",
            10,
        );
        const comparePrice =
            comparePriceCents > 0 && comparePriceCents > currentPriceCents
                ? formatMoney(comparePriceCents)
                : "";

        if (subscriptionPrice) {
            addToCartButton.innerHTML = `<span class="button__text">${priceLabel}</span><span class="button__price"><span class="old-price">${price}</span> <span class="new-price">${subscriptionPrice}</span></span>`;
        } else if (comparePrice) {
            addToCartButton.innerHTML = `<span class="button__text">${priceLabel}</span><span class="button__price"><span class="old-price">${comparePrice}</span> <span class="new-price">${price}</span></span>`;
        } else {
            addToCartButton.innerHTML = `<span class="button__text">${priceLabel}</span><span class="button__price"><span class="new-price">${price}</span></span>`;
        }

        addToCartButton.setAttribute("aria-label", `${priceLabel} ${price}`);
    }

    if (!init()) {
        const observer = new MutationObserver(() => {
            if (init()) {
                observer.disconnect();
            }
        });
        const rechargeWidget = document.querySelector(
            "recharge-subscription-widget",
        );
        if (rechargeWidget?.shadowRoot) {
            observer.observe(rechargeWidget.shadowRoot, {
                childList: true,
                subtree: true,
            });
        } else {
            observer.observe(document.body, {childList: true, subtree: true});
        }
    }
})();
